import { DayHeaderContentArg } from '@fullcalendar/react'
import { isToday } from 'date-fns'

import { getDay } from './date'

export function dayHeaderClassNames(e: DayHeaderContentArg) {
  return isToday(e.date) ? 'FullCalendarHeaderCurrentDay' : ''
}
